// Configuration dayjs centralisée (~7 Ko) — remplace moment (~70 Ko) dans le
// bundle initial. Plugins activés pour couvrir les formats utilisés dans l'app :
//  - relativeTime    : .fromNow()
//  - customParseFormat: dayjs(str, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
//  - localizedFormat : formats localisés (L, LL, LLL, lll…)
//  - advancedFormat  : tokens ordonnés (Do, Qo…)
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/en";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);

export default dayjs;
